import React from 'react';
import { Modal, Input } from 'antd';

interface StartPlayoutModalProps {
  open: boolean;
  value: string;
  onConfirm: () => void;
  onCancel: () => void;
  onChange: (value: string) => void;
}

const StartPlayoutModal: React.FC<StartPlayoutModalProps> = ({
  open,
  value,
  onConfirm,
  onCancel,
  onChange
}) => {
  return (
    <Modal
      title="Start Playout"
      open={open}
      onOk={onConfirm}
      onCancel={onCancel}
      okText="Start"
      cancelText="Cancel"
    >
      <div>
        <p>Enter the minute to start from (optional, defaults to 0):</p>
        <Input
          type="number"
          min={0}
          placeholder="0"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onPressEnter={onConfirm}
          autoFocus
        />
      </div>
    </Modal>
  );
};

export default StartPlayoutModal;
